import {Component} from '@angular/core';

@Component({
    templateUrl: './error-400.component.html',
    styleUrls: ['./error-400.component.scss'],
    standalone: false
})
export class Error400Component {

}
